import { render, staticRenderFns } from "./deductionList.vue?vue&type=template&id=48553c79&scoped=true"
import script from "./deductionList.vue?vue&type=script&lang=js"
export * from "./deductionList.vue?vue&type=script&lang=js"
import style0 from "./deductionList.vue?vue&type=style&index=0&id=48553c79&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48553c79",
  null
  
)

export default component.exports